<!-- Modern Professional Footer - Single Line Design -->
<footer class="footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="footer-content d-flex align-items-center justify-content-between">
      
      <!-- Left Section: Copyright & Brand -->
      <div class="copyright-section d-flex align-items-center gap-2">
        <mat-icon class="footer-icon">copyright</mat-icon>
        <span class="copyright-text">
          {{currentYear}}  <span class="brand-name">  Vkomak Technologies</span>
        </span>
      </div>
      
      <!-- Right Section: Timestamp & Scroll Button -->
      <div class="right-section d-flex align-items-center gap-3">
        <!-- Status & Time -->
        <div class="timestamp-container d-flex align-items-center gap-2">
          <div class="status-indicator"></div>
          <mat-icon class="time-icon">schedule</mat-icon>
          <span class="timestamp">{{currentTime | date:'HH:mm'}}</span>
          <span class="timestamp-separator">•</span>
          <mat-icon class="date-icon">today</mat-icon>
          <span class="timestamp">{{currentTime | date:'dd-MMM-yyyy'}}</span>
        </div>
        
        <!-- Scroll to Top Button -->
        <button 
          class="scroll-top-btn" 
          (click)="scrollToTop()"
          matTooltip="Back to top"
          aria-label="Scroll to top">
          <mat-icon class="arrow-icon">north</mat-icon>
        </button>
      </div>
      
    </div>
  </div>
</footer>
